/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { RatingRequestBody } from '../model/ratingRequestBody';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TracksService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Mark the trackLink as blocked
     * 
     * @param trackLinkId The track id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markBlocked(trackLinkId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public markBlocked(trackLinkId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public markBlocked(trackLinkId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public markBlocked(trackLinkId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (trackLinkId === null || trackLinkId === undefined) {
            throw new Error('Required parameter trackLinkId was null or undefined when calling markBlocked.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<any>(`${this.getBasePath()}/api/v1/tracks/${encodeURIComponent(String(trackLinkId))}/block`,
            null,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mark the track as favorite
     * 
     * @param trackLinkId The trackLink id
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markFavorite(trackLinkId: number, body?: RatingRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public markFavorite(trackLinkId: number, body?: RatingRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public markFavorite(trackLinkId: number, body?: RatingRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public markFavorite(trackLinkId: number, body?: RatingRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (trackLinkId === null || trackLinkId === undefined) {
            throw new Error('Required parameter trackLinkId was null or undefined when calling markFavorite.');
        }


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.getBasePath()}/api/v1/tracks/${encodeURIComponent(String(trackLinkId))}/favorite`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mark the trackLink as unblocked
     * 
     * @param trackLinkId The track id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unmarkBlocked(trackLinkId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public unmarkBlocked(trackLinkId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public unmarkBlocked(trackLinkId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public unmarkBlocked(trackLinkId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (trackLinkId === null || trackLinkId === undefined) {
            throw new Error('Required parameter trackLinkId was null or undefined when calling unmarkBlocked.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.getBasePath()}/api/v1/tracks/${encodeURIComponent(String(trackLinkId))}/block`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unmark the track as favorite
     * 
     * @param trackLinkId The trackLink id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unmarkFavorite(trackLinkId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public unmarkFavorite(trackLinkId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public unmarkFavorite(trackLinkId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public unmarkFavorite(trackLinkId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (trackLinkId === null || trackLinkId === undefined) {
            throw new Error('Required parameter trackLinkId was null or undefined when calling unmarkFavorite.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.getBasePath()}/api/v1/tracks/${encodeURIComponent(String(trackLinkId))}/favorite`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
